module.exports = __webpack_public_path__ + "static/media/ws.ee288230.svg";